module.exports = __webpack_public_path__ + "img/hsbc.a0d4d04a.svg";